module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAAXNSR0IB2cksfwAAABtQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlFHiIAAAAAl0Uk5TABBg/+/gUN/wy/dZ6QAAAGhJREFUeJxjYBBkAAMgxWSiAGIxOSswiBgbgZjKxo4MrMbGQGEmY+MABjZjkLCysXECmFRgAvNBckbKYFVgYYggWBgqCBaGCCIzkRQgtCEZhrACyWK4cwoYJGCObGRgsoA4vVmBAeEhAKPbFLekceLwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-files-exit@2x.png
// module id = 788
// module chunks = 0